// extracted by mini-css-extract-plugin
export default {"basic":"SurfaceTitle_basic_hcdLZ","small":"SurfaceTitle_small_d0CxN"};